export const environment = {
    production: true,
    url: "/api/",
    socketUrl: "/"
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/environments/environment.prod.ts